<sh-generic-overview
    [searchBarMode]="$searchBarMode()"
    [searchBarActionItems]="searchBarActionItems$ | async"
    [fieldSearchOptions]="$fieldSearchOptions()"
    [displayMode]="$view()"
    [displayOptions]="$viewOptions()"
    [showViewToggle]="$showViewToggle()"
    [sortInfo]="$sort()"
    [sortOptions]="$sortOptions()"
    [allowSort]="$allowSort()"
    [resultsPerPageOptions]="$pageSizeOptions()"
    [paginatedResults]="searchPageResults$ | async"
    [actionItems]="actions$ | async"
    [contextActionGroup]="contextActions$ | async"
    [pictureFillMode]="$imageFitModeSetting()"
    [areItemsClickable]="$allowItemClick()"
    [availableSelect]="$allowSelection()"
    [canBatchSelect]="$allowBatchSelection()"
    [allSelected]="initialBatchSelect"
    [selectedItems]="selectedItems$ | async"
    [activeItem]="$activeItem()"
    [columns]="columns$ | async"
    [columnOptions]="columnOptions$ | async"
    [isLoading]="loading$ | async"
    [hasError]="error$ | async"
    [noItemsSelectedLabelKey]="$noItemsSelectedLabelKey()"
    [itemsSelectedLabelKey]="$itemsSelectedLabelKey()"
    [xxResultsLabelKey]="$xxResultsLabelKey()"
    [noResultsLabelKey]="$noResultsLabelKey()"
    [disableSelectMessage]="'general.no-batch-select'"
    (paginationInfoChanged)="onPaginationInfoChanged($event)"
    (sortInfoChanged)="onSortInfoChanged($event)"
    (displayModeChanged)="onViewChanged($event)"
    (itemClicked)="onRowClicked($event)"
    (actionModeChanged)="onActionModeChanged($event)"
    (thumbnailClicked)="onThumbnailClicked($event)"
    (itemsChecked)="onSelectedItemsChanged($event)"
    (columnSelectionChanged)="onColumnSelectionChanged($event)"
></sh-generic-overview>
